<template>
    <div>
        <div class="page-container">
            <div class="titie">购置情况</div>
            <div class="search">
                <el-row :gutter="20">
                    <el-col style="width: 65px"><span class="search-desc">搜索</span></el-col>
                    <el-col :xs="24" :lg="4"><el-input size="medium" placeholder="请输入搜索内容" v-model="key"></el-input></el-col>
                    <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>
                </el-row>
            </div>
            <Table
                ref="table"
                v-loading="LoadingTable"
                :headerData="headerData"
                :tableData="tableData"
                :tableText="tableText"
                :tableCount="tableCount"
                :border="true"
                @changeTable="changeTable"
            >
                <el-table-column fixed="right" label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button @click="checkDetail(scope.row)" type="text" size="small">购置详细</el-button>
                    </template>
                </el-table-column>
            </Table>
        </div>
    </div>
</template>

<script>
    import Table from 'components/Table';
    import { Header } from './headerData.js';
    import useCondition from 'api/Management/useCondition.js';
    const _useCondition = new useCondition();
    export default {
        data() {
            return {
                key: '',
                per_page: 10,
                page: 1,
                dialogFormVisible: false,
                storageNum: '',
                // 表单必须数据
                headerData: Header,
                tableData: [], // 表格数据
                tableText: '加载中',
                tableCount: 0,
                selectedStr: '', // 选择的表格选择字符串
                currentPage: 1, // 当前页
                currentPageLength: 10, // 当前页长度
                LoadingTable: false, //当前table的loading
            };
        },
        mounted() {
            this.getUselist();
        },
        methods: {
            getUselist() {
                // this.tableData = [];
                this.tableText = '加载中';
                this.LoadingTable = true;
                _useCondition
                    .getUselist(this.currentPageLength, this.currentPage, this.key)
                    .then(res => {
                        this.tableData = res.items;
                        this.tableCount = res._meta.totalCount;
                        if (res.items.length === 0) {
                            this.tableText = '暂无数据';
                        }
                    })
                    .finally(_ => {
                        this.LoadingTable = false;
                    });
            },
            // 改变页数/页长度
            changeTable({ currentPage, pageLength }) {
                // this.tableData = [];
                // 临时存储当前页/当前页长度
                this.currentPage = currentPage;
                this.currentPageLength = pageLength;
                // this.per_page = pageLength;
                this.getUselist();
            },
            controlFormWindow(flag) {
                this.dialogFormVisible = flag;
            },
            // 查看
            checkDetail(row) {
                this.$router.push({ path: `/gs/useCondition/Table/${row.ORDER_NO}` });
            },
            handleSearch() {
                this.$refs.table.handleCurrentChange(1);
            },
        },
        components: {
            Table,
        },
    };
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    .titie {
      width 100%
      height 30px
      line-height 30px
      font-size:16px;
      font-family:SimSun;
      font-weight:bold;
      color:rgba(62,62,62,1)
      text-align center
    }
</style>
